import React, { MouseEvent } from 'react';

import {
  LbModal,
  LbModalProps,
  ButtonConfig,
} from '../../../components/modals/LbModal/LbModal';
import { openModal } from '../../../utils/reactUtils/openModal/openModal';

type OpenConfirmationModalProps = {
  confirmBtnConfig: ButtonConfig;
  cancelBtnConfig?: ButtonConfig;
} & Omit<LbModalProps, 'open' | 'primaryBtnConfig' | 'secondaryBtnConfig'>;
type HandleCloseModal = () => void;

const openConfirmationModal = ({
  confirmBtnConfig,
  cancelBtnConfig,
  ...props
}: OpenConfirmationModalProps): HandleCloseModal =>
  openModal((closeModal) => {
    const handleConfirm = (event: MouseEvent<HTMLButtonElement>) => {
      confirmBtnConfig?.onClick(event);
      closeModal();
    };

    const handleCancel = (event: MouseEvent<HTMLButtonElement>) => {
      cancelBtnConfig?.onClick(event);
      closeModal();
    };

    return (
      <LbModal
        open
        {...props}
        primaryBtnConfig={{ ...confirmBtnConfig, onClick: handleConfirm }}
        secondaryBtnConfig={{ ...cancelBtnConfig, onClick: handleCancel }}
      />
    );
  });

export { openConfirmationModal, OpenConfirmationModalProps };
